export const TASKASSIGN_PLAN_TYPE = "task_assignment";
export const TASKASSIGN_JSON_VERSION = 1;
export function buildAssignmentJsonExport(input) {
    return {
        planType: TASKASSIGN_PLAN_TYPE,
        version: TASKASSIGN_JSON_VERSION,
        exportedAt: new Date().toISOString(),
        parameters: input.parameters,
        sonuclar: {
            atama_sonuclari: {
                tarih_atama_sonuclari: input.tarihAtamaSonuclari,
            },
            izin_takvimi: input.izinTakvimi || {},
            uyumsuzluk_listesi: input.uyumsuzlukListesi || [],
            sofor_istatistikleri: input.soforIstatistikleri || {},
            genel_istatistikler: input.genelIstatistikler || {},
            acik_gorev_ozeti: input.acikGorevOzeti || [],
        },
        frontendChanges: input.frontendChanges,
    };
}
export function parseAssignmentJsonImport(raw) {
    if (!raw || typeof raw !== "object") {
        return { ok: false, error: "Geçersiz JSON." };
    }
    const obj = raw;
    if (obj.planType && obj.planType !== TASKASSIGN_PLAN_TYPE) {
        return {
            ok: false,
            error: `Bu dosya görev atama planı değil (${String(obj.planType)}).`,
        };
    }
    let sonuclar = (obj.sonuclar || {});
    if (!obj.sonuclar && obj.gun_bazli_atamalar) {
        sonuclar = {
            atama_sonuclari: { tarih_atama_sonuclari: obj },
        };
    }
    const atama = (sonuclar.atama_sonuclari || {});
    const tarih = atama.tarih_atama_sonuclari || sonuclar.tarih_atama_sonuclari;
    if (!tarih || typeof tarih !== "object") {
        return { ok: false, error: "Dosyada atama sonucu (tarih_atama_sonuclari) yok." };
    }
    return {
        ok: true,
        data: {
            planType: TASKASSIGN_PLAN_TYPE,
            version: Number(obj.version || TASKASSIGN_JSON_VERSION),
            exportedAt: String(obj.exportedAt || ""),
            parameters: obj.parameters || undefined,
            sonuclar: {
                ...sonuclar,
                atama_sonuclari: {
                    ...atama,
                    tarih_atama_sonuclari: tarih,
                },
            },
            frontendChanges: obj.frontendChanges || undefined,
        },
    };
}
export function downloadJsonFile(data, filename) {
    const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
